import React from 'react';
import { endPoints } from 'shared/config/endPoints';
import { IRoute } from '../types';
import { Navigate } from 'react-router-dom';
import { Auth } from 'pages/Auth';

export const loginRoutes = (merchant_id: string): IRoute[] => [
  {
    path: endPoints.LOGIN,
    element: <Auth />,
  },
  {
    path: '*',
    element: (
      <Navigate
        to={`${endPoints.LOGIN.replace(':merchant_id', merchant_id)}`}
      />
    ),
  },
];
